import { useTranslations } from 'next-intl';
import { Cork as IconCork } from '../../../../../components/icons';

export default function UserCorks(props: { corks: number }) {
  const t = useTranslations('loyalty');

  return (
    <div className="tw-bg-gradient-to-r tw-from-primary tw-to-[#ef5989] tw-text-white tw-p-4 tw-rounded-2xl tw-space-y-1.5 tw-flex tw-flex-col tw-items-center tw-w-72">
      <h6 className="tw-text-xl tw-font-bold tw-tracking-tight tw-m-0 tw-p-0 tw-text-white">
        {t('wallet.header.yourCorks')}
      </h6>
      <div className="tw-flex tw-items-center tw-gap-1.5">
        <IconCork />
        <h2 className="tw-text-4xl tw-font-bold tw-tracking-tight tw-m-0 tw-p-0 tw-text-white">
          {props.corks}
        </h2>
      </div>
    </div>
  );
}
